export enum ExaminationLinkDataTest {
    LinkInput = 'examination-linjk_link-input',
    SaveButton = 'examination-linjk_save-button',
}
